import { getReportReviewSheetTemplate } from '../helper/get-report-review-sheet-template';
import { allReportReasons } from '../helper/report-reasons';
import { trackEvent } from '../../../_common/client/tracking';
import { CustomerReviewBackendRequester } from './customer-review-backend-requester';
import { sheetV1 } from '@otto-ec/otto-components/sheet';
import { push as showSnackbar } from '@otto-ec/otto-components/snackbar/v1';

export class ReportReviewSheetService {
    private readonly successSnackbarText: string =
        'Vielen Dank für deine Hilfe! Ein Mitarbeiter wird die von dir gemeldete Kundenbewertung schnellstmöglich prüfen.';

    constructor(private customerReviewBackendRequester: CustomerReviewBackendRequester) {}

    public async openSheet(reviewId: string, reviewPosition: number): Promise<void> {
        const sheet = await sheetV1.create({
            id: 'pdp_cr-item__report-review-sheet',
            headline: 'Kundenbewertung melden',
        });
        sheet.innerHTML = getReportReviewSheetTemplate(allReportReasons);

        this.registerOnSubmitButtonClick(sheet, () => this.reportReview(sheet, reviewId, reviewPosition));
        this.registerOnRadioButtonChange(sheet, () => this.hideSheetErrorMessage(sheet));

        sheet.open = true;
    }

    private registerOnSubmitButtonClick(sheet: HTMLOcSheetV1Element, onSubmitButtonClick: () => void) {
        this.getSubmitButton(sheet)?.addEventListener('click', onSubmitButtonClick);
    }

    private registerOnRadioButtonChange(sheet: HTMLOcSheetV1Element, onChange: () => void) {
        window.o_util.event.delegate(sheet, 'change', '.js_pdp_cr_report-review-list__radio', onChange);
    }

    private reportReview(sheet: HTMLOcSheetV1Element, reviewId: string, reviewPosition: number) {
        const selectedReportReason = this.getSelectedReportReason(sheet);

        if (!selectedReportReason) {
            this.makeErrorMessageVisible(sheet);
            return;
        }

        this.trackSubmitAction(selectedReportReason, reviewPosition);
        this.customerReviewBackendRequester.reportReview(reviewId, selectedReportReason);
        sheet.close();
        showSnackbar(this.successSnackbarText);
    }

    private hideSheetErrorMessage(sheet: HTMLOcSheetV1Element): void {
        const selectedRadioButton = sheet?.querySelector('.js_pdp_cr_report-review-list__radio:checked');
        if (selectedRadioButton) {
            sheet.querySelector('.js_pdp_cr_report-review-sheet__error')?.classList.add('pl_hidden');
        }
    }

    private trackSubmitAction(selectedReportReason: string, reviewPosition: number) {
        trackEvent({
            review_ReportReview: 'send',
            review_SingleReviewPosition: reviewPosition,
            review_SingleReviewReason: selectedReportReason,
        });
    }

    private makeErrorMessageVisible(sheet: HTMLOcSheetV1Element) {
        sheet.querySelector('.js_pdp_cr_report-review-sheet__error')?.classList.remove('pl_hidden');
    }

    private getSelectedReportReason(sheet: HTMLOcSheetV1Element) {
        return sheet.querySelector<HTMLInputElement>('.js_pdp_cr_report-review-list__radio:checked')?.value;
    }

    private getSubmitButton(sheet: HTMLOcSheetV1Element) {
        return sheet.querySelector<HTMLElement>('.js_pdp_cr_report-review-sheet__submit');
    }
}
